













































import { Component, Prop } from 'vue-property-decorator';
import EntityType from '@/models/Shared/EntityType';
import WorkerStatus from '@/components/Workers/Display/WorkerStatus.vue';
import { CompanyDetailsModule } from '@/store/modules/companyDetails';
import { LocationDetailsModule } from '@/store/modules/locationDetails';
import { WorkerDetailsModule } from '@/store/modules/workerDetails';
import DocumentUpload from '@/components/Documents/DocumentUpload.vue';
import DocumentEdit from '@/components/Documents/DocumentEdit.vue';
import GiganautVue from '@/components/Shared/GiganautVue';
import FileUtils from '@/lib/fileUtils';
import { ComplianceModule } from '@/store/modules/compliance';
import OpenEntityInNewWindowBtn from '../Shared/OpenEntityInNewWindowBtn.vue';
import DocumentExpiryDate from '@/components/Documents/Display/DocumentExpiryDate.vue';
import ExpiryTrackedDocumentDto from '@/models/Documents/ExpiryTrackedDocumentDto';
import PageNames from '@/router/PageNames';


@Component({
  name: 'ComplianceDocuments',
  components: { DocumentEdit, WorkerStatus, DocumentExpiryDate }
})
export default class extends GiganautVue {

    @Prop()
    entityType: EntityType;

    get documents() {
        switch (this.entityType){
            case EntityType.Worker:
                return ComplianceModule.workerDocuments;
            case EntityType.Company:
                return ComplianceModule.companyDocuments;
            case EntityType.Location:
                return ComplianceModule.locationDocuments;
        }
    }

    async navigateToEntity(item: ExpiryTrackedDocumentDto) {
        if (item.entityType === EntityType.Worker) {
            this.$router.push({ name: PageNames.AgencyWorkerDetails, params: { workerid: item.entityId } });
        } else if (item.entityType === EntityType.Company) {
            this.$router.push({ name: PageNames.AgencyCompanyDetails, params: { companyid: item.entityId } });
        } else if (item.entityType === EntityType.Location) {
            this.$router.push({ name: PageNames.AgencyLocationDetails, params: { locationid: item.entityId } });
        }
    }

    icon(fileExtension: string) {
        return FileUtils.getMdiIconForExtension(fileExtension);
    }

    async download(document: ExpiryTrackedDocumentDto) {
        await ComplianceModule.downloadDocument(document);
    }

    private headers = [
        { text: 'Name', value: 'entityName' },
        { text: 'Document Name', value: 'name' },
        { text: 'Document Expires', value: 'expiresAt' },
        { text: 'Actions'},
    ]
}
